export default __webpack_public_path__ + "static/media/erpClock.45c476be.svg";